import {
  AfterViewChecked,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  NgZone,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { ConnectedPosition, Overlay } from '@angular/cdk/overlay';
import { connectedPositionsBottomRightPriority } from '@immosky/shared';

@Component({
  selector: 'app-filter-dropdown',
  templateUrl: './filter-dropdown.component.html',
  styleUrls: ['./filter-dropdown.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FilterDropdownComponent implements OnInit, AfterViewChecked {
  isDropdownOpen = false;
  isScrollable = false;

  @Input()
  dropdownButtonTemplate!: TemplateRef<unknown>;

  @Input()
  dropdownContentTemplate!: TemplateRef<unknown>;

  @Input()
  applyButtonTemplate!: TemplateRef<unknown>;

  @Input()
  isOpen = false;

  @Input()
  preferredWidth = 0;

  @Input()
  maxHeight = 0;

  @Input()
  hasValue = false;

  @ViewChild('scrollContainer')
  scrollContainerRef!: ElementRef<HTMLDivElement>;

  @Output()
  clear = new EventEmitter<void>();

  overlayPositions: ConnectedPosition[] = connectedPositionsBottomRightPriority;

  templateContext = {
    close: this.close.bind(this),
  };

  get scrollStrategy() {
    return this.overlay.scrollStrategies.block();
  }

  get dropdownMinWidth(): string {
    return this.preferredWidth ? `${this.preferredWidth}px` : 'auto';
  }

  get dropdownMaxHeight(): string {
    return this.maxHeight ? `${this.maxHeight}px` : 'auto';
  }

  constructor(
    private ngZone: NgZone,
    private cdRef: ChangeDetectorRef,
    private overlay: Overlay
  ) {}

  ngOnInit(): void {
    this.isDropdownOpen = this.isOpen;
    this.cdRef.markForCheck();
  }

  ngAfterViewChecked(): void {
    this.updateIsScrollable();
  }

  private updateIsScrollable() {
    if (this.isDropdownOpen) {
      window.requestAnimationFrame(() => {
        if (this.scrollContainerRef) {
          const scrollContainer = this.scrollContainerRef.nativeElement;
          this.isScrollable =
            scrollContainer.scrollHeight > scrollContainer.clientHeight;
          this.cdRef.detectChanges();
        }
      });
    }
  }

  toggleDropdown() {
    if (this.isDropdownOpen) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    this.isDropdownOpen = true;
    this.cdRef.markForCheck();
  }

  close() {
    window.requestAnimationFrame(() => {
      this.isDropdownOpen = false;
      this.cdRef.markForCheck();
    });
  }

  onReset(event: MouseEvent) {
    event.stopPropagation();
    this.clear.emit();
  }
}
